// extracted by mini-css-extract-plugin
module.exports = {"PrideMonthBanner":"styles_PrideMonthBanner__1FK_9"};